function i(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
export {
  i as default
};
//# sourceMappingURL=rectToClientRect.mjs.map
